import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { AppRouteConstants } from "src/app/shared/constants/app-route.constants";
import { StorageService } from "src/app/shared/services/storage.service";
import { StudentSession } from "src/app/shared/models/student-session";
@Component({
    selector: "session-management",
    templateUrl: "./session-management.component.html",
    styleUrls: ["./session-management.component.css"],
    standalone: false
})
//This component is under development and may contain unused code.
export class SessionManagement implements OnInit {
  tutorId: number;
  tutorTipModal=false;
  tabIndex = 0;
  sessionData: StudentSession ;

  constructor(
    public _location: Location,
    private router: Router,
  ) {
  }
  onTabChange(index: number) {
    this.tabIndex = index;
  }
  ngOnInit() {
    if (this.router.url.search(AppRouteConstants.TUTOR_UPDATE_PROGRESS) > 0) {
      localStorage.setItem(
        "previousURL",
        AppRouteConstants.TUTOR_UPDATE_PROGRESS
      );
    }
    this.sessionData= StorageService.getSessionData();
    this.tabIndex=this.sessionData?.current_page || 0 ;
    this.tutorId = Number(StorageService.getUserId());
  }
}
